export default {
    navigationBarTitleText: intl.get('mobileLandingPage.title.intelligentDesign'),
    navigationBarBackgroundColor: "#DF773C",
};
